import { inject, observer } from "mobx-react";
import ButtonUI from "@UI/ButtonUI";
import { confirmDialog } from "primereact/confirmdialog";
import { pluralForm } from "@utils";
import moment from "moment";

import "./style.scss";

const ActivationFooter = inject("mainStore")(
    observer(({ mainStore, selectedItems, handleDeleteMany = () => {}, data }) => {
        const filter = mainStore.getMainStore("filter");

        const dataDelete = selectedItems
            ? selectedItems.map((m) => {
                  return { offer_id: m.offer_id, site_id: m.site_id, date: moment(m.date).format("YYYY-MM-DD") };
              })
            : [];

        const confirmDelete = () => {
            confirmDialog({
                message: `Вы выбрали ${selectedItems.length} запис${pluralForm(selectedItems.length, ["ь", "и", "ей"])} в загруженных активациях`,
                header: "Вы уверены, что хотите удалить?",
                icon: "pi pi-exclamation-triangle",
                defaultFocus: "accept",
                rejectLabel: "Отмена",
                acceptLabel: "Удалить",
                rejectClassName: "p-button-danger",
                accept: () => handleDeleteMany(dataDelete),
            });
        };

        const downloadStats = async () => {
            const payload = {
                startDate: filter.startDate,
                endDate: filter.endDate,
                siteIds: filter.filters.siteIds || [],
                vendorIds: filter.filters.vendorIds || [],
                offerIds: filter.filters.offerIds || [],
            };

            await mainStore.downloadFile(
                "/promo/activationoffersReport",
                payload,
                {
                    headers: {
                        "content-type": "application/json",
                    },
                    responseType: "blob",
                },
                "activations.csv",
                true,
            );
        };

        const fullTotal = data && data.data?.reduce((acc, val) => (acc += val.count), 0);

        return (
            <div className="activation-footer">
                {fullTotal ? `Тотал: ${fullTotal.toFixed(2)}` : null}
                {selectedItems?.length > 0 ? <ButtonUI outlined severity="danger" icon="pi pi-trash" onClick={confirmDelete} label={`Удалить ${selectedItems.length} запис${pluralForm(selectedItems.length, ["ь", "и", "ей"])}`} /> : null}
                <ButtonUI outlined severity="success" icon="pi pi-download" label={`Скачать статистику`} onClick={downloadStats} />
            </div>
        );
    }),
);

export default ActivationFooter;
